// src/data/exercises/L2_01.js

const accountOptions = [
  '資本金', '当座預金', '現金', '普通預金', '有価証券'];

export const L2_01 = {
  title: '簿記　3級（第218-1回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {
       parts: [
        { type: 'ruby', text: '株式会社設立', ruby: 'かぶしきがいしゃせつりつ' },
        { type: 'text', value: 'に' },
        { type: 'ruby', text: '際', ruby: 'さい' },
        { type: 'text', value: 'し、' },
        { type: 'ruby', text: '株式', ruby: 'かぶしき' },
        { type: 'text', value: '500' },
        { type: 'ruby', text: '株', ruby: 'かぶ' },
        { type: 'text', value: 'を＠￥3,000で' },
        { type: 'ruby', text: '発行', ruby: 'はっこう' },
        { type: 'text', value: 'し、' },
        { type: 'ruby', text: '全額', ruby: 'ぜんがく' },
        { type: 'text', value: 'が' },
        { type: 'ruby', text: '普通預金口座', ruby: 'ふつうよきんこうざ' },
        { type: 'text', value: 'に' },
        { type: 'ruby', text: '払', ruby: 'はら' },
        { type: 'text', value: 'い' },
        { type: 'ruby', text: '込', ruby: 'こ' },
        { type: 'text', value: 'まれた。' }
    ],
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '普通預金', debitAmount: 1500000, creditAccount: '資本金', creditAmount: 1500000 },
      ],

      // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '「株式会社設立　株式　発行」なので、\n' },
          { type: 'text', value: '①資本金が増加（プラス）です。\n' },
          { type: 'styled', value: '資本金は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '「全額の払い込みを受け、当座預金とした」なので、\n' },
          { type: 'text', value: '②普通預金が増加（プラス）です。\n' },
          { type: 'styled', value: '普通預金は借方（左・Ｄｒ）に記入します。', color: 'red', bold: true },
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`「株式会社設立　株式　発行」なので、
資本金の増加（プラス）です。

「全額が普通預金口座に払い込まれた」なので、
②普通預金が増加（プラス）です。`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
            parts: [
          { type: 'text', value: '「株式会社設立　株式　発行」なので、\n' },
          { type: 'text', value: '①資本金が増加（プラス）です。\n' },
          { type: 'styled', value: '資本金は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '「全額の払い込みを受け、当座預金とした」なので、\n' },
          { type: 'text', value: '②普通預金が増加（プラス）です。\n' },
          { type: 'styled', value: '普通預金は借方（左・Ｄｒ）に記入します。', color: 'red', bold: true },
        ]
          }
        ],
       
        
      },
    },
  ],
};